<script>
import lazyLoadComponent from '@router/lazyload-component'
import { merchantComputed, authComputed } from '@state/helpers'

export default {
  components: {
    // BaseInputFloatingLabel: () => import('@components/BaseInputFloatingLabel'),
    // BaseUpload: () => import('@components/BaseUpload'),
    ImageUpload: () => lazyLoadComponent(import('@views/chat/components/FileUpload')),
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // submitData: this.defaultValue,
      // limit:{
      //   year:0,
      //   month:0,
      //   day:0
      // }
    }
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
    submitData: {
      get() {
        return this.defaultValue
      },
      set(value) {
        this.$emit('update:defaultValue', value)
      },
    },
    // canSetPrice() {
    //   return this.$can('api', 'setPrice')
    // },
    // formRules() {
    //   return {
    //     title: [
    //       {
    //         required: true,
    //         message: '請輸入包月方案名稱',
    //       },
    //     ],
    //     categoryId: [
    //       {
    //         required: true,
    //         message: '請選擇類別',
    //       },
    //     ],
    //     groupAlias: [
    //       {
    //         required: true,
    //         message: '請輸入包月網址別名',
    //       },
    //     ],
    //     // basePrice: [
    //     //   {
    //     //     required: true,
    //     //     message: '請輸入原價',
    //     //     // trigger: 'change',
    //     //   },
    //     // ],
    //     // price: [
    //     //   {
    //     //     required: true,
    //     //     message: '請輸入售價',
    //     //     // trigger: 'change',
    //     //   },
    //     // ],
    //     infinity: [
    //       {
    //         required: true,
    //         message: '請選擇庫存數量',
    //         // trigger: 'change',
    //       },
    //     ],
    //     times: [
    //       {
    //         required: true,
    //         message: '請輸入可抵扣次數',
    //         // trigger: 'change',
    //       },
    //     ],
    //   }
    // },
    // currentCategory() {
    //   return this.category.filter((item) => {
    //     return item.children.length > 0
    //   })
    // },
    isEditMode() {
      return !!this.defaultValue.groupOrdering
    },
    // productBaseBookingUrl() {
    //   // return `${this.merchantUrl}/booking/${this.currentProductAlias}/`
    //   let url = ''
    //   if (window.globalData.APP_ENV === 'local') {
    //     url = this.merchantUrl
    //   } else {
    //     const prefixUrl = this.merchantUrl.split('//', 2)
    //     url = `${prefixUrl[0]}//${this.currentMerchant.alias}.${prefixUrl[1]}`
    //     // url = `${prefixUrl[0]}//${this.currentMerchant.alias}.${prefixUrl[1]}/reservation/`
    //   }
    //   return url
    // },
    // homeServicePrepaidUrl() {
    //   return `${this.productBaseBookingUrl}/${this.storeType}/prepaid/包月網址別名`
    // },
    // storeType() {
    //   return `商店類型`
    // },
  },
  created() {},
  methods: {
    deleteSave() {
      if (this.isEditMode) {
        this.$emit('update')
      }
    },
    validate() {
      return this.$refs.form.validate()
    },
  },
}
</script>

<template>
  <div :class="$style.pageContent">
    <div class="isStylePageContent">
      <el-form ref="form" :model="submitData" :validate-on-rule-change="false" label-position="top" :class="$style.form" autocomplete="off">
        <h4 class="form-block-title">圖片設定</h4>
        <!-- <el-col :sm="24" :span="24"> -->
          <el-form-item prop="images">
            <template v-if="!$hasSpecial()">
              <ImageUpload v-model="submitData.images" is-delete-save :class="$style.upload" :show-upload="true" :resource="'prepaid'" @deleteSave="deleteSave"></ImageUpload>
              <div :class="[$style.limit]" >
                圖檔最大 10 MB，檔案格式限 JPG 、 PNG 、 SVG 、 GIF
                <span>圖片比例：16 : 9，</span>建議尺寸：360*270px
              </div>
            </template>
            <template v-if="$hasSpecial()">
              <ImageUpload v-model="submitData.images" is-delete-save :class="$style.upload" :show-upload="true" :resource="'prepaid'" @deleteSave="deleteSave"></ImageUpload>
              <div :class="[$style.limit]" >
                圖檔最大 10 MB，檔案格式限 JPG 、 PNG 、 SVG 、 GIF
                <br />
                建議尺寸：720*350px
              </div>
            </template>
          </el-form-item>
        <!-- </el-col> -->
      </el-form>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
@import '@src/design/layout_detail_steps.scss';
.form {
  :global {
    .el-input-group__prepend {
      padding-left: 0;
    }
  }
}
.limit {
  margin-top: 10px;
  line-height: 1.5;
  color: $color-text-light;
}
%img-size {
  width: calc(50% - 10px);
  height: 216px;
  @include max-md {
    width: calc(100%);
  }
}
:global {
  :local(.upload) {
    margin: 0 -10px;
    border-top: none !important;
    > div {
      @extend %img-size;
    }

    .image-and-action {
      @extend %img-size;
      & + div {
        @extend %img-size;
      }
    }
  }
}
.form-item--split {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;

  :global {
    .el-radio-group {
      flex-shrink: 0;
      margin-right: 15px;
    }
    .el-input {
      // max-width: 150px;
    }
  }
}
</style>
